var MAIN = (function(MAIN, $, window, document, undefined){
  MAIN.isTouchDevice = ('ontouchstart' in document.documentElement);

  MAIN.isLocalEnv = function(){
    if (!window || !window.location) return false;
    var protocol = window.location.protocol;
    var host = (window.location.hostname || '').toLowerCase();
    if (protocol === 'file:') return true;
    // Treat the live domain as "not local". Everything else is considered local/non-live.
    // This intentionally includes staging/preview domains in "local" so tracking/geo-ip are suppressed there too.
    return !(host === 'mustimpress.com' || host.endsWith('.mustimpress.com'));
  }

  // Fire a function once.
  MAIN.fireOnce = function(key, fn){
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
    fn();
  };

  // Keep a rAF loop alive through iOS / momentum scrolling, where scroll
  // events get sparse as the gesture decelerates. updateFn(dtSeconds) may
  // return true to keep sampling until a smoothed value has settled.
  function bindScrollFrame(updateFn){
    var running = false;
    var lastEventTs = 0;
    var lastFrameTs = 0;
    var idleMs = 400;

    function nowMs(){
      return (window.performance && typeof performance.now === 'function') ? performance.now() : Date.now();
    }

    function loop(frameTs){
      var dt = lastFrameTs ? Math.min(0.05, (frameTs - lastFrameTs) / 1000) : 0.016;
      lastFrameTs = frameTs;
      var keepGoing = updateFn(dt) === true;
      if (keepGoing || (frameTs - lastEventTs) < idleMs) {
        window.requestAnimationFrame(loop);
      } else {
        running = false;
        lastFrameTs = 0;
        updateFn(0);
      }
    }

    function kick(){
      lastEventTs = nowMs();
      if (!running) {
        running = true;
        lastFrameTs = 0;
        window.requestAnimationFrame(loop);
      }
    }

    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('touchmove', kick, { passive: true });
    window.addEventListener('touchend', kick, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', kick, { passive: true });
    }
    window.addEventListener('scrollend', kick);
    UTIL.onLayoutSettle(kick);
    updateFn(0);
  }

  function approachValue(current, target, dt){
    if (!Number.isFinite(current)) {
      return target;
    }
    if (dt <= 0) {
      return target;
    }
    var delta = target - current;
    var abs = Math.abs(delta);
    if (abs < 0.00001) {
      return target;
    }
    // Snap when far behind (finger still moving fast); ease when samples
    // thin out at the end of iOS momentum.
    var rate = abs > 0.08 ? 48 : 16;
    return current + delta * (1 - Math.exp(-rate * dt));
  }


  // Tooltips.
  // function tooltip() {
  //   if (typeof tippy === 'undefined'){
  //     return;
  //   }

  //   // Keep tooltip triggers from acting like hash links.
  //   $('body').on('click', '.tip', function(e){
  //     e.preventDefault();
  //   });

  //   tippy('.tip', {
  //     content(reference) {
  //       return reference.getAttribute('data-tooltip');
  //     }
  //   });
  // }

  // #work tiles: "View" label that trails the cursor.
  function workItemCursorTip(){
    if (MAIN.isTouchDevice) {
      return;
    }
    if (window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      return;
    }

    var $work = $('#work');
    if (!$work.length) {
      return;
    }

    var tip = document.createElement('div');
    tip.className = 'work-cursor-tip';
    tip.setAttribute('aria-hidden', 'true');
    tip.textContent = 'View';
    document.body.appendChild(tip);

    var offsetX = 13;
    var offsetY = 13;
    var showDelayMs = 200;
    var ease = 0.16;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      ease = 1;
    }

    var hovering = false;
    var visible = false;
    var showTimeoutId = null;
    var x = 0;
    var y = 0;
    var targetX = 0;
    var targetY = 0;
    var ticking = false;

    function setTransform(){
      tip.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
    }

    function tick(){
      var dx = targetX - x;
      var dy = targetY - y;
      if (Math.abs(dx) < 0.15 && Math.abs(dy) < 0.15) {
        x = targetX;
        y = targetY;
        ticking = false;
      } else {
        x += dx * ease;
        y += dy * ease;
        window.requestAnimationFrame(tick);
      }
      setTransform();
    }

    function requestTick(){
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(tick);
      }
    }

    function pointFromEvent(e){
      targetX = e.clientX + offsetX;
      targetY = e.clientY + offsetY;
    }

    function clearShowTimeout(){
      if (showTimeoutId) {
        window.clearTimeout(showTimeoutId);
        showTimeoutId = null;
      }
    }

    function reveal(){
      if (!hovering || visible) {
        return;
      }
      x = targetX;
      y = targetY;
      setTransform();
      tip.classList.add('is-visible');
      visible = true;
      requestTick();
    }

    function show(e){
      pointFromEvent(e);
      hovering = true;
      if (visible) {
        requestTick();
        return;
      }
      if (showTimeoutId) {
        return;
      }
      showTimeoutId = window.setTimeout(function(){
        showTimeoutId = null;
        reveal();
      }, showDelayMs);
    }

    function hide(){
      hovering = false;
      visible = false;
      clearShowTimeout();
      tip.classList.remove('is-visible');
    }

    $work.on('mouseenter.workCursorTip', '.item a', show);
    $work.on('mousemove.workCursorTip', '.item a', function(e){
      pointFromEvent(e);
      if (!hovering) {
        show(e);
        return;
      }
      if (visible) {
        requestTick();
      }
    });
    $work.on('mouseleave.workCursorTip', '.item a', hide);
  }

  // Lazyload images.
  // function lazyload(){
  //   if (!(typeof $.fn.lazyload === 'function' || typeof window.lazyload === 'function')) {
  //     return;
  //   }
  //   var $targets = $('img[data-src], img[data-srcset]');
  //   if (!$targets.length){
  //     return;
  //   }

  //   $targets.each(function(){
  //     var $img = $(this);
  //     if (!$img.hasClass('lazyload')){
  //       $img.addClass('lazyload');
  //     }
  //     if (!$img.attr('loading')){
  //       $img.attr('loading', 'lazy');
  //     }
  //   });

  //   var options = {
  //     rootMargin: '300px 300px',
  //     threshold: 0.01,
  //     src: 'data-src',
  //     srcset: 'data-srcset'
  //   };
  //   $targets.lazyload(options);
  // }

  // Clients grid: reveal items in order as #clients scrolls through the viewport.
  function clientLogosScrollReveal(){
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var $grid = $('.client-grid');
    if (!$grid.length) {
      return;
    }

    var sectionEl = $grid.closest('section').get(0);
    if (!sectionEl) {
      return;
    }

    var items = $grid.children('.grid-item').get();
    var n = items.length;
    if (!n) {
      return;
    }

    $grid.addClass('client-grid--scroll-reveal');

    // Number of item-slots used to blend reveal progress between neighbors.
    var revealBlendSpanItems = 3;
    // Starting vertical offset (in px) for unrevealed items.
    var itemRevealOffsetPx = 100;
    // Starting blur/opacity for unrevealed items.
    var itemStartBlurPx = 6;
    var itemStartOpacity = 0;
    // Section progress range where the reveal animation is active.
    var animationStartProgress = 0.2;
    var animationEndProgress = 0.7;

    function sectionProgress01(){
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      var vh = UTIL.svh();
      var rect = sectionEl.getBoundingClientRect();
      var elHeight = sectionEl.offsetHeight;
      var track = elHeight + vh;
      if (track <= 0) {
        return 0;
      }
      var elTop = scrollY + rect.top;
      var startScroll = elTop - vh;
      var p = (scrollY - startScroll) / track;
      if (p < 0) {
        return 0;
      }
      if (p > 1) {
        return 1;
      }
      return p;
    }

    function smoothstep01(t){
      if (t <= 0) {
        return 0;
      }
      if (t >= 1) {
        return 1;
      }
      return t * t * (3 - 2 * t);
    }

    function setItemRevealed(el, t){
      var u = smoothstep01(t);
      var opacity = itemStartOpacity + ((1 - itemStartOpacity) * u);
      var blurPx = itemStartBlurPx * (1 - u);
      el.style.opacity = String(opacity);
      el.style.filter = (blurPx > 0.01) ? ('blur(' + blurPx + 'px)') : 'none';
      el.style.transform = 'translate3d(0, ' + ((1 - u) * itemRevealOffsetPx) + 'px, 0)';
    }

    function setItemFull(el){
      el.style.opacity = '1';
      el.style.filter = 'none';
      el.style.transform = 'translate3d(0, 0, 0)';
    }

    function clearItem(el){
      el.style.opacity = String(itemStartOpacity);
      el.style.filter = (itemStartBlurPx > 0.01) ? ('blur(' + itemStartBlurPx + 'px)') : 'none';
      el.style.transform = 'translate3d(0, ' + itemRevealOffsetPx + 'px, 0)';
    }

    function update(){
      var vh = UTIL.svh();
      if (vh <= 0) {
        return;
      }

      var rect = sectionEl.getBoundingClientRect();
      var i;

      if (rect.bottom < 0) {
        for (i = 0; i < n; i++) {
          setItemFull(items[i]);
        }
        return;
      }

      if (rect.top > vh) {
        for (i = 0; i < n; i++) {
          clearItem(items[i]);
        }
        return;
      }

      var p = sectionProgress01();
      var pNorm = (p - animationStartProgress) / (animationEndProgress - animationStartProgress);
      if (pNorm < 0) {
        pNorm = 0;
      }
      if (pNorm > 1) {
        pNorm = 1;
      }

      var revealHead = pNorm * (n - 1 + revealBlendSpanItems);

      for (i = 0; i < n; i++) {
        var raw = (revealHead - i) / revealBlendSpanItems;
        if (raw <= 0) {
          clearItem(items[i]);
        } else if (raw >= 1) {
          setItemFull(items[i]);
        } else {
          setItemRevealed(items[i], raw);
        }
      }
    }

    var ticking = false;
    function onScrollOrResize(){
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(function(){
          ticking = false;
          update();
        });
      }
    }

    update();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
  }

  function projectsIntroSettings(){
    return {
      // Hold fully expanded before the transition begins.
      // Can be any non-negative number; larger means longer hold.
      delay: 1,
      // Relative scroll distance used to complete the transition.
      transitionSpan: 1.9,
      // Scroll pixels represented by one progress unit.
      scrollUnitVh: 65,
      // Maximum width for the fullscreen proxy start state.
      proxyMaxWidth: 2000,
      // Background grid reveal timing within first item transition (0..1).
      gridRevealStart: 0.2,
      gridRevealEnd: 0.92,
      // Background grid start scale before revealing.
      gridRevealStartScale: 0.88,
      // Proxy .fade fades out during first-item shrink (0..1 of sectionProgress01).
      proxyFadeOutStart: 0,
      proxyFadeOutEnd: 0.22
    };
  }

  function projectsIntroScrollPx(config){
    var vh = Math.max(1, UTIL.scrollVh());
    var unitPx = Math.max(1, vh * ((config.scrollUnitVh || 65) / 100));
    return Math.max(0, (Math.max(0, config.delay || 0) + Math.max(0, config.transitionSpan || 0)) * unitPx);
  }

  // Projects grid: first item starts by covering grid, then settles into cell one on scroll.
  function projectsScrollIntro(){
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var $section = $('#projects');
    if (!$section.length) {
      return;
    }
    var sectionEl = $section.get(0);
    var $wrapper = $('#work');
    var wrapperEl = $wrapper.get(0) || sectionEl.parentElement;
    if (!wrapperEl) {
      return;
    }

    var $grid = $section.find('.grid').first();
    var gridEl = $grid.get(0);
    if (!gridEl) {
      return;
    }

    var itemEls = $grid.children('.item').toArray();
    if (itemEls.length < 2) {
      return;
    }

    var firstEl = itemEls[0];
    var backgroundGridItems = itemEls.slice(1);
    var contentGridEl = $section.find('.content-grid').first().get(0);
    var contentScrollEl = $section.find('.content-scroll').first().get(0);
    var proxyHostEl = $section.find('.container-limit').first().get(0) || sectionEl;
    var firstProxyEl = firstEl.cloneNode(true);
    firstProxyEl.classList.add('item--intro-proxy');
    firstProxyEl.setAttribute('aria-hidden', 'true');
    firstProxyEl.style.position = 'absolute';
    firstProxyEl.style.left = '0';
    firstProxyEl.style.top = '0';
    firstProxyEl.style.margin = '0';
    firstProxyEl.style.zIndex = '2';
    firstProxyEl.style.display = 'none';
    firstProxyEl.style.overflow = 'hidden';
    firstProxyEl.style.background = '#f4f4f4';
    firstProxyEl.style.willChange = 'left, top, width, height, border-radius';
    var proxyImgEl = $(firstProxyEl).find('img').first().get(0);
    if (proxyImgEl) {
      // proxyImgEl.style.display = 'block';
      // proxyImgEl.style.width = '100%';
      // proxyImgEl.style.height = '100%';
      // proxyImgEl.style.objectFit = 'cover';
    }
    var proxyLinkEl = $(firstProxyEl).find('a').first().get(0);
    if (proxyLinkEl) {
      proxyLinkEl.style.display = 'block';
      proxyLinkEl.style.width = '100%';
      proxyLinkEl.style.height = '100%';
      proxyLinkEl.setAttribute('tabindex', '-1');
    }
    var proxyFadeEl = $(firstProxyEl).find('.hero-cover-wrapper .fade').first().get(0);
    proxyHostEl.appendChild(firstProxyEl);

    var config = projectsIntroSettings();
    var delay = Math.max(0, config.delay || 0);
    var transitionSpan = Math.max(0.0001, config.transitionSpan || 0);
    var gridRevealStart = clamp01(config.gridRevealStart || 0);
    var gridRevealEnd = clamp01(config.gridRevealEnd || 1);
    if (gridRevealEnd <= gridRevealStart) {
      gridRevealEnd = Math.min(1, gridRevealStart + 0.001);
    }
    var gridRevealStartScale = config.gridRevealStartScale || 0.88;
    if (gridRevealStartScale <= 0) {
      gridRevealStartScale = 0.01;
    }
    var proxyMaxWidth = Math.max(1, config.proxyMaxWidth || 2000);
    var proxyFadeOutStart = clamp01(config.proxyFadeOutStart || 0);
    var proxyFadeOutEnd = clamp01(config.proxyFadeOutEnd || 1);
    if (proxyFadeOutEnd <= proxyFadeOutStart) {
      proxyFadeOutEnd = Math.min(1, proxyFadeOutStart + 0.001);
    }

    var geom = {
      startLeft: 0,
      startTop: 0,
      startWidth: 0,
      startHeight: 0,
      endLeft: 0,
      endTop: 0,
      endWidth: 0,
      endHeight: 0,
      endRadiusPx: 0,
      ready: false
    };

    function clamp01(v){
      if (v <= 0) {
        return 0;
      }
      if (v >= 1) {
        return 1;
      }
      return v;
    }

    function easeInOut(t){
      return t * t * (3 - 2 * t);
    }

    function sectionProgressRaw(){
      var vh = UTIL.scrollVh(wrapperEl);
      if (vh <= 0) {
        return 1;
      }
      var wrapperRect = wrapperEl.getBoundingClientRect();
      // Start once wrapper reaches viewport top; then progress with wrapper scroll.
      if (wrapperRect.top > 0) {
        return 0;
      }
      var unitPx = Math.max(1, vh * ((config.scrollUnitVh || 65) / 100));
      return (-wrapperRect.top) / unitPx;
    }

    function captureGeometry(){
      firstEl.style.transform = 'none';
      firstEl.style.zIndex = '2';
      firstEl.style.borderRadius = '';
      firstEl.style.visibility = '';
      firstProxyEl.style.display = 'none';

      if (!updateEndGeometry()) {
        geom.ready = false;
        return;
      }

      var vw = Math.max(1, window.innerWidth || document.documentElement.clientWidth || 1);

      // Start fullscreen at top of viewport, then settle to real first-item rect.
      // Paint with lvh so the cover fills the collapsed iOS chrome; scroll math stays on svh.
      geom.startLeft = 0;
      geom.startTop = 0;
      geom.startWidth = Math.min(vw, proxyMaxWidth);
      geom.startHeight = UTIL.lvh();
      geom.ready = true;
    }

    function updateEndGeometry(){
      var firstRect = firstEl.getBoundingClientRect();
      var hostRect = proxyHostEl.getBoundingClientRect();
      if (firstRect.width <= 0 || firstRect.height <= 0) {
        return false;
      }
      geom.endLeft = firstRect.left - hostRect.left;
      geom.endTop = firstRect.top - hostRect.top;
      geom.endWidth = firstRect.width;
      geom.endHeight = firstRect.height;
      geom.endRadiusPx = parseFloat(window.getComputedStyle(firstEl).borderTopLeftRadius) || 0;
      return true;
    }

    function sectionProgress01(){
      // Keep this raw so delay can be any non-negative value (including > 1).
      var pRaw = sectionProgressRaw();
      // Hold at 0 until delay is reached; then animate over transitionSpan.
      return clamp01((pRaw - delay) / transitionSpan);
    }

    function render(){
      if (!geom.ready) {
        return;
      }
      if (!updateEndGeometry()) {
        return;
      }

      var transitionProgress = sectionProgress01();
      var eased = easeInOut(transitionProgress);
      var left = geom.startLeft + ((geom.endLeft - geom.startLeft) * eased);
      var top = geom.startTop + ((geom.endTop - geom.startTop) * eased);
      var width = geom.startWidth + ((geom.endWidth - geom.startWidth) * eased);
      var height = geom.startHeight + ((geom.endHeight - geom.startHeight) * eased);
      var radiusPx = geom.endRadiusPx * eased;
      var wrapperRect = wrapperEl.getBoundingClientRect();
      var fadeOutT = 1 - clamp01((transitionProgress - proxyFadeOutStart) / (proxyFadeOutEnd - proxyFadeOutStart));
      var contentScrollOpacity = contentScrollEl ? parseFloat(window.getComputedStyle(contentScrollEl).opacity) : 1;
      if (!Number.isFinite(contentScrollOpacity)) {
        contentScrollOpacity = 1;
      }
      contentScrollOpacity = clamp01(contentScrollOpacity);
      var proxyFadeOpacity = clamp01(contentScrollOpacity * fadeOutT);

      if (wrapperRect.top > 0) {
        // Keep proxy visible in its fullscreen start state before transition begins.
        firstProxyEl.style.display = 'block';
        firstProxyEl.style.left = geom.startLeft + 'px';
        firstProxyEl.style.top = geom.startTop + 'px';
        firstProxyEl.style.width = geom.startWidth + 'px';
        firstProxyEl.style.height = geom.startHeight + 'px';
        firstProxyEl.style.borderRadius = '0px';
        firstEl.style.visibility = 'hidden';
        firstEl.style.transform = 'none';
        firstEl.style.borderRadius = '';
        firstEl.style.zIndex = '1';
      } else if (eased >= 0.999) {
        firstProxyEl.style.display = 'none';
        firstEl.style.visibility = '';
        firstEl.style.transform = 'none';
        firstEl.style.borderRadius = '';
        firstEl.style.zIndex = '2';
      } else {
        firstProxyEl.style.display = 'block';
        firstProxyEl.style.left = left + 'px';
        firstProxyEl.style.top = top + 'px';
        firstProxyEl.style.width = width + 'px';
        firstProxyEl.style.height = height + 'px';
        firstProxyEl.style.borderRadius = radiusPx + 'px';
        firstEl.style.visibility = 'hidden';
        firstEl.style.zIndex = '1';
      }
      if (proxyFadeEl) {
        proxyFadeEl.style.opacity = String(proxyFadeOpacity);
      }

      if (backgroundGridItems.length) {
        var revealT = clamp01((eased - gridRevealStart) / (gridRevealEnd - gridRevealStart));
        var revealEased = easeInOut(revealT);
        var bgScale = gridRevealStartScale + ((1 - gridRevealStartScale) * revealEased);
        var i;
        for (i = 0; i < backgroundGridItems.length; i++) {
          backgroundGridItems[i].style.opacity = String(revealEased);
          backgroundGridItems[i].style.transform = 'scale(' + bgScale + ')';
          backgroundGridItems[i].style.transformOrigin = '50% 50%';
          backgroundGridItems[i].style.willChange = 'transform, opacity';
        }
        if (eased >= 0.999) {
          for (i = 0; i < backgroundGridItems.length; i++) {
            backgroundGridItems[i].style.opacity = '';
            backgroundGridItems[i].style.transform = '';
            backgroundGridItems[i].style.transformOrigin = '';
            backgroundGridItems[i].style.willChange = '';
          }
        }
      }

      if (contentGridEl) {
        contentGridEl.style.setProperty('--content-grid-padding', (1 * eased) + 'rem');
        contentGridEl.style.padding = 'var(--content-grid-padding)';
      }
    }

    var ticking = false;
    function onScrollOrResize(){
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(function(){
          ticking = false;
          if (!geom.ready) {
            captureGeometry();
          }
          render();
        });
      }
    }

    captureGeometry();
    render();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', function(){
      captureGeometry();
      onScrollOrResize();
    });
  }

  // Shared region state handler:
  // - toggles .region-active
  // - updates body theme vars from .region data attributes
  // - pauses .video-wrapper videos when a region is not .region-active
  function regionStateOnScroll(){
    var $body = $('body');
    if (!$body.length) {
      return;
    }
    var bodyEl = $body.get(0);

    var regions = $('.region').toArray();
    if (!regions.length) {
      return;
    }

    var regionStates = new WeakMap();
    var preparedVideos = new WeakSet();
    var wrapperVideoLocks = new WeakSet();
    var lastBg = null;
    var lastColor = null;
    var lastHighlight = null;
    var lastHighlightColor = null;
    var lastHeaderFade = null;
    var activeThemeRegionEl = null;

    function isThemeRegion(regionEl){
      if (!regionEl || !$(regionEl).is('.theme')) {
        return false;
      }
      return $(regionEl).is('[data-bg], [data-color], [data-highlight], [data-highlight-color]');
    }

    function regionPreset(regionEl, attrName){
      var raw = UTIL.attr(regionEl, attrName);
      if (raw == null || raw === '') {
        return null;
      }
      return String(raw).trim().toLowerCase();
    }

    function triggerYForPreset(preset, vh){
      // early: ~25% of incoming/outgoing section is in view (line at 75% viewport).
      // late: section reaches ~25% viewport height from top.
      // complete: section edge reaches the viewport top.
      if (preset === 'complete') {
        return 0;
      }
      if (preset === 'late') {
        return vh * 0.25;
      }
      return vh * 0.75;
    }

    function triggerYForRegion(regionEl, vh){
      return triggerYForPreset(regionPreset(regionEl, 'data-start') || 'early', vh);
    }

    function hasRegionEnded(regionEl, rect, vh){
      var end = regionPreset(regionEl, 'data-end');
      if (!end) {
        return false;
      }
      return rect.bottom <= triggerYForPreset(end, vh);
    }

    function applyThemeFromRegion(regionEl){
      var bg = UTIL.attr(regionEl, 'data-bg');
      var color = UTIL.attr(regionEl, 'data-color');
      var highlight = UTIL.attr(regionEl, 'data-highlight');
      var highlightColor = UTIL.attr(regionEl, 'data-highlight-color');

      bg = bg ? String(bg).trim() : '';
      color = color ? String(color).trim() : '';
      highlight = highlight ? String(highlight).trim() : '';
      highlightColor = highlightColor ? String(highlightColor).trim() : '';

      if (bg !== lastBg) {
        if (bg) {
          bodyEl.style.setProperty('--body-background', bg);
        } else {
          bodyEl.style.removeProperty('--body-background');
        }
        lastBg = bg;
      }

      if (color !== lastColor) {
        if (color) {
          bodyEl.style.setProperty('--body-color', color);
        } else {
          bodyEl.style.removeProperty('--body-color');
        }
        lastColor = color;
      }

      if (highlight !== lastHighlight) {
        if (highlight) {
          bodyEl.style.setProperty('--color-highlight', highlight);
        } else {
          bodyEl.style.removeProperty('--color-highlight');
        }
      }

      if (highlightColor !== lastHighlightColor) {
        if (highlightColor) {
          bodyEl.style.setProperty('--color-highlight-color', highlightColor);
        } else {
          bodyEl.style.removeProperty('--color-highlight-color');
        }
      }

      var headerFadeRaw = regionPreset(regionEl, 'data-header-fade');
      var headerFade = (headerFadeRaw !== 'false' && headerFadeRaw !== '0' && headerFadeRaw !== 'off') ? '1' : '0';
      if (headerFade !== lastHeaderFade) {
        bodyEl.style.setProperty('--header-fade-opacity', headerFade);
        lastHeaderFade = headerFade;
      }
    }

    function pickActiveThemeRegion(vh){
      var i;
      var crossedEl = null;
      var crossedTop = -Infinity;
      var bestEl = null;
      var bestDistance = Infinity;

      for (i = 0; i < regions.length; i++) {
        var regionEl = regions[i];
        if (!isThemeRegion(regionEl)) {
          continue;
        }

        var rect = regionEl.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= vh) {
          continue;
        }
        if (hasRegionEnded(regionEl, rect, vh)) {
          continue;
        }

        var triggerY = triggerYForRegion(regionEl, vh);
        if (rect.top <= triggerY) {
          // Among sections whose own trigger has been crossed, pick the most
          // recent one in view (largest top), so incoming sections take over.
          if (rect.top > crossedTop) {
            crossedTop = rect.top;
            crossedEl = regionEl;
          }
        }

        // Fallback before crossing: nearest visible region top to its trigger.
        var distance = Math.abs(rect.top - triggerY);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestEl = regionEl;
        }
      }
      return crossedEl || bestEl;
    }

    function getRegionVideos(regionEl){
      if (!regionEl) {
        return [];
      }
      return $(regionEl).find('video').not('.video-wrapper video').toArray();
    }

    function getWrapperVideos(regionEl){
      if (!regionEl) {
        return [];
      }
      return $(regionEl).find('.video-wrapper video').toArray();
    }

    function getVideoPlaybackRate(videoEl){
      var rateAttr = videoEl.getAttribute('playbackrate');
      if (!rateAttr) {
        return null;
      }
      var rate = parseFloat(String(rateAttr).trim());
      if (!Number.isFinite(rate) || rate <= 0) {
        return null;
      }
      return rate;
    }

    function applyVideoPlaybackRate(videoEl){
      var rate = getVideoPlaybackRate(videoEl);
      if (rate === null) {
        return;
      }

      // Set both values for better cross-browser reliability.
      try {
        videoEl.defaultPlaybackRate = rate;
      } catch (e) {}
      try {
        videoEl.playbackRate = rate;
      } catch (e) {}
    }

    function prepareVideoPlaybackRate(videoEl){
      if (preparedVideos.has(videoEl)) {
        return;
      }
      preparedVideos.add(videoEl);

      if (getVideoPlaybackRate(videoEl) === null) {
        return;
      }

      videoEl.addEventListener('loadedmetadata', function(){
        applyVideoPlaybackRate(videoEl);
      });
      videoEl.addEventListener('play', function(){
        applyVideoPlaybackRate(videoEl);
      });
      applyVideoPlaybackRate(videoEl);
    }

    function playVideo(videoEl){
      applyVideoPlaybackRate(videoEl);
      var playPromise = videoEl.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function(){});
      }
    }

    function lockWrapperVideo(videoEl, regionEl){
      if (wrapperVideoLocks.has(videoEl)) {
        return;
      }
      wrapperVideoLocks.add(videoEl);

      function pauseIfInactive(){
        if (!regionEl.classList.contains('region-active')) {
          videoEl.pause();
        }
      }

      videoEl.addEventListener('play', pauseIfInactive);
      videoEl.addEventListener('loadeddata', pauseIfInactive);
      pauseIfInactive();
    }

    function syncWrapperVideos(regionEl, isActive){
      var videos = getWrapperVideos(regionEl);
      var j;
      for (j = 0; j < videos.length; j++) {
        prepareVideoPlaybackRate(videos[j]);
        lockWrapperVideo(videos[j], regionEl);
        if (isActive) {
          if (videos[j].paused) {
            playVideo(videos[j]);
          }
        } else if (!videos[j].paused) {
          videos[j].pause();
        }
      }
    }

    function syncRegionActiveClass(activeRegionEl){
      var i;
      for (i = 0; i < regions.length; i++) {
        var regionEl = regions[i];
        var isActive = regionEl === activeRegionEl;
        $(regionEl).toggleClass('region-active', isActive);
        syncWrapperVideos(regionEl, isActive);
      }
    }

    function triggerActiveCallback(regionEl){
      if (!regionEl) {
        return;
      }
      var callbackPath = UTIL.attr(regionEl, 'data-active-callback');
      if (!callbackPath) {
        return;
      }
      callbackPath = String(callbackPath).trim();
      if (!callbackPath) {
        return;
      }
      window.UTIL.invokeFunctionByPath(callbackPath, [regionEl], window);
    }

    function updateRegions(){
      var vh = UTIL.svh() || document.documentElement.clientHeight || 1;
      var i;

      for (i = 0; i < regions.length; i++) {
        var regionEl = regions[i];
        var isVisible = window.UTIL.isElementVisible(regionEl, vh);
        var wasVisible = regionStates.get(regionEl);

        $(regionEl).toggleClass('region-visible', isVisible);

        if (wasVisible !== isVisible) {
          regionStates.set(regionEl, isVisible);

          var videos = getRegionVideos(regionEl);
          var j;
          for (j = 0; j < videos.length; j++) {
            prepareVideoPlaybackRate(videos[j]);
            if (isVisible) {
              playVideo(videos[j]);
            } else {
              videos[j].pause();
            }
          }
        }
      }

      var nextActiveThemeRegionEl = pickActiveThemeRegion(vh);
      if (nextActiveThemeRegionEl === activeThemeRegionEl) {
        syncRegionActiveClass(activeThemeRegionEl);
        if (activeThemeRegionEl) {
          applyThemeFromRegion(activeThemeRegionEl);
        }
        return;
      }
      activeThemeRegionEl = nextActiveThemeRegionEl;
      syncRegionActiveClass(activeThemeRegionEl);
      if (activeThemeRegionEl) {
        applyThemeFromRegion(activeThemeRegionEl);
        triggerActiveCallback(activeThemeRegionEl);
      }
    }

    var ticking = false;
    function onScrollOrResize(){
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(function(){
          ticking = false;
          updateRegions();
        });
      }
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    updateRegions();
  }

  // .content-visible: toggle .visible when the leading edge is on screen
  // (top while scrolling down, bottom while scrolling up).
  function contentVisibleOnScroll(){
    var els = $('.content-visible').toArray();
    if (!els.length) {
      return;
    }

    var lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var scrollingDown = true;

    function isEdgeOnScreen(el, vh, useBottom){
      var rect = el.getBoundingClientRect();
      var y = useBottom ? rect.bottom : rect.top;
      return y < vh && y >= 0;
    }

    function update(){
      var currentScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (currentScrollY !== lastScrollY) {
        scrollingDown = currentScrollY > lastScrollY;
        lastScrollY = currentScrollY;
      }
      var vh = UTIL.svh() || document.documentElement.clientHeight || 1;
      var useBottom = !scrollingDown;
      var i;
      for (i = 0; i < els.length; i++) {
        els[i].classList.toggle('visible', isEdgeOnScreen(els[i], vh, useBottom));
      }
    }

    var ticking = false;
    function onScrollOrResize(){
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(function(){
          ticking = false;
          update();
        });
      }
    }

    update();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
  }

  // Trigger callbacks when [data-visible-callback] elements become visible.
  function visibleCallbacksOnScroll(){
    var callbackEls = $('[data-visible-callback]').toArray();
    if (!callbackEls.length) {
      return;
    }

    var callbackStates = new WeakMap();

    function updateVisibleCallbacks(){
      var vh = UTIL.svh() || document.documentElement.clientHeight || 1;
      var i;
      for (i = 0; i < callbackEls.length; i++) {
        var el = callbackEls[i];
        var isVisible = window.UTIL.isElementVisible(el, vh);
        var wasVisible = callbackStates.get(el);
        if (wasVisible === isVisible) {
          continue;
        }
        callbackStates.set(el, isVisible);
        if (!isVisible) {
          continue;
        }

        var callbackPath = UTIL.attr(el, 'data-visible-callback');
        if (!callbackPath) {
          continue;
        }
        callbackPath = String(callbackPath).trim();
        if (!callbackPath) {
          continue;
        }
        window.UTIL.invokeFunctionByPath(callbackPath, [el], window);
      }
    }

    var ticking = false;
    function onScrollOrResize(){
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(function(){
          ticking = false;
          updateVisibleCallbacks();
        });
      }
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    updateVisibleCallbacks();
  }

  // Toggle body class based on scroll direction.
  function bodyScrollDirectionClass(){
    var $body = $('body');
    if (!$body.length) {
      return;
    }

    var lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var directionThresholdPx = 40;
    var ticking = false;

    function updateDirectionClass(){
      var currentScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var deltaY = currentScrollY - lastScrollY;

      if (Math.abs(deltaY) < directionThresholdPx) {
        ticking = false;
        return;
      }

      if (deltaY > 0) {
        $body.addClass('scroll-down').removeClass('scroll-up');
      } else {
        $body.removeClass('scroll-down').addClass('scroll-up');
      }

      if (currentScrollY <= 0) {
        $body.removeClass('scroll-down scroll-up');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function(){
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateDirectionClass);
      }
    }, { passive: true });
  }

  // Projects: pin #projects while wrapper scrolls.
  function projectsPinArticle(){
    if (typeof $.fn.fixx !== 'function') {
      console.log('jQuery.fn.fixx is not loaded (check bundle build/cache)');
      return;
    }

    var $section = $('#projects');
    if (!$section.length) {
      return;
    }
    var $wrapper = $('#work');
    if (!$wrapper.length) {
      return;
    }

    var config = {
      // Space from viewport top while pinned.
      offset: 0,
      // Extra pixels after #projects reaches top before pinning starts.
      startThreshold: 0,
      // Tweak where pinning stops relative to endElement.
      endThreshold: 0
    };
    var introConfig = projectsIntroSettings();
    var endMarkerClass = 'projects-pin-end';
    var $endElement = $wrapper.children('.' + endMarkerClass).first();
    if (!$endElement.length) {
      $endElement = $('<div class="' + endMarkerClass + '" aria-hidden="true"></div>');
      $wrapper.append($endElement);
    }

    function pinFrameHeight(){
      var gridEl = $section.find('.content-grid').get(0);
      if (gridEl) {
        var gridH = gridEl.getBoundingClientRect().height;
        if (gridH > 0) {
          return Math.ceil(gridH);
        }
      }
      var raw = window.getComputedStyle($section.get(0)).getPropertyValue('--project-items-min-height').trim();
      var vh = Math.max(1, UTIL.svh() || document.documentElement.clientHeight || 1);
      var match = raw.match(/^([\d.]+)(?:[sld])?vh$/i);
      if (match) {
        return Math.ceil((parseFloat(match[1]) / 100) * vh);
      }
      return vh;
    }

    function updatePinRunway(){
      var transitionScrollPx = projectsIntroScrollPx(introConfig);
      var framePx = pinFrameHeight();
      var markerTop = Math.ceil(transitionScrollPx + framePx);

      $wrapper.css({
        minHeight: markerTop,
        position: 'relative'
      });
      $endElement.css({
        position: 'absolute',
        left: 0,
        top: markerTop,
        width: 1,
        height: 1,
        pointerEvents: 'none'
      });
    }

    updatePinRunway();
    UTIL.onLayoutSettle(updatePinRunway);
    $(window).on('load.projectsPinArticle', updatePinRunway);
    window.requestAnimationFrame(updatePinRunway);

    var gridEl = $section.find('.content-grid').get(0);
    if (gridEl && typeof ResizeObserver === 'function') {
      var runwayResizeObserver = new ResizeObserver(function(){
        updatePinRunway();
      });
      runwayResizeObserver.observe(gridEl);
    }

    $section.fixx({
      offset: config.offset,
      startElement: $wrapper,
      startAt: 'top',
      startThreshold: config.startThreshold,
      endElement: $endElement,
      endAt: 'top',
      endThreshold: config.endThreshold,
      fixedBreakpoints: ['xs', 'sm', 'md', 'lg'],
      placeholder: true,
      stateFixedClass: 'fixed',
      stateStaticClass: 'static',
      stateFreezeClass: 'freeze'
    });
  }

  function contentScrollHasPause($panel, $section){
    var pauseRaw = UTIL.attr($panel, 'data-intro-pause-for');
    if (pauseRaw == null || String(pauseRaw).trim() === '') {
      return false;
    }
    if (!(UTIL.lengthToVh(pauseRaw, $panel.get(0)) > 0)) {
      return false;
    }
    var pauseAtRaw = UTIL.attr($panel, 'data-intro-pause-at');
    var pauseAtNorm = (pauseAtRaw == null) ? '' : String(pauseAtRaw).trim().toLowerCase();
    if (pauseAtNorm !== '' && pauseAtNorm !== 'bottom') {
      return Number.isFinite(parseFloat(pauseAtNorm));
    }
    return $section.find('.pause-placeholder').length > 0;
  }

  // Keep each case-study (and other paused) section on screen while its
  // intro plays. GSAP only scrubs 0–1 against this runway; it does not pin.
  function contentScrollPausePin(){
    if (typeof $.fn.fixx !== 'function') {
      return;
    }

    var skipParentIds = {
      work: true
    };

    $('.content-scroll').each(function(){
      var $panel = $(this);
      var $section = $panel.closest('section');
      if (!$section.length) {
        return;
      }
      if ($section.attr('id') === 'projects') {
        return;
      }

      var parent = $section.parent().get(0);
      if (!parent) {
        return;
      }
      if (skipParentIds[parent.id] || $(parent).hasClass('content-scroll-pin-wrap')) {
        return;
      }

      var inCaseStudy = parent.id === 'case-study';
      if (!inCaseStudy && !contentScrollHasPause($panel, $section)) {
        return;
      }

      $section.wrap('<div class="content-scroll-pin-wrap"></div>');
      var $wrapper = $section.parent();
      var $endElement = $('<div class="content-scroll-pin-end" aria-hidden="true"></div>');
      $wrapper.append($endElement);

      function motionSpanPx(){
        // Scroll distance only. The section itself remains a full 100lvh.
        var vh = Math.max(1, UTIL.scrollVh($panel));
        var spanVh = UTIL.attrNumber($panel, 'data-intro-motion-span-vh');
        if (spanVh == null || spanVh <= 0) {
          spanVh = 100;
        }
        var pauseVh = UTIL.lengthToVh(UTIL.attr($panel, 'data-intro-pause-for') || '0', $panel.get(0));
        if (!Number.isFinite(pauseVh) || pauseVh < 0) {
          pauseVh = 0;
        }
        return (spanVh / 100) * vh + (pauseVh / 100) * vh;
      }

      function updatePinRunway(){
        var transitionScrollPx = motionSpanPx();
        var sectionHeight = Math.max(1, UTIL.lvh());
        var markerTop = Math.ceil(transitionScrollPx + sectionHeight);

        $wrapper.css({
          minHeight: markerTop,
          position: 'relative'
        });
        $endElement.css({
          position: 'absolute',
          left: 0,
          top: markerTop,
          width: 1,
          height: 1,
          pointerEvents: 'none'
        });
      }

      updatePinRunway();
      UTIL.onLayoutSettle(updatePinRunway);

      $section.fixx({
        offset: 0,
        startElement: $wrapper,
        startAt: 'top',
        startThreshold: 0,
        endElement: $endElement,
        endAt: 'top',
        endThreshold: 0,
        fixedBreakpoints: ['xs', 'sm', 'md', 'lg'],
        placeholder: true,
        leftPositioning: true,
        stateFixedClass: 'fixed',
        stateStaticClass: 'static',
        stateFreezeClass: 'freeze'
      });
    });
  }

  MAIN.count = function(){
    var $stats = $('#stats');
    if (!$stats.length) {
      return;
    }

    var $window = $(window);
    var $countEls = $stats.find('.count');
    var scrollNamespace = 'scroll.countStats';
    var delayMs = 400;
    var durationMs = 2000;

    function clearPending(){
      $window.off(scrollNamespace);
      if (MAIN._countTimeoutId) {
        window.clearTimeout(MAIN._countTimeoutId);
        MAIN._countTimeoutId = null;
      }
    }

    // One-shot counter: once started, keep final values on future views.
    if (MAIN._countHasRun) {
      clearPending();
      return;
    }

    function getTargetValue($el){
      var storedTarget = parseInt($el.attr('data-count-target'), 10);
      if (Number.isFinite(storedTarget)) {
        return storedTarget;
      }

      var currentText = String($el.text() || '').replace(/[^\d.-]/g, '');
      var parsed = parseInt(currentText, 10);
      var target = Number.isFinite(parsed) ? parsed : 0;
      $el.attr('data-count-target', String(target));
      return target;
    }

    function startCountAnimation(){
      MAIN._countHasRun = true;
      clearPending();

      var i;
      for (i = 0; i < $countEls.length; i++) {
        var $el = $($countEls[i]);
        var target = getTargetValue($el);
        $el.stop(true, true);
        $el.text('0');
        $el.prop('Counter', 0).animate({
          Counter: target
        }, {
          duration: durationMs,
          easing: 'swing',
          step: function(now){
            $(this).text(Math.ceil(now));
          },
          complete: function(){
            var finalTarget = parseInt($(this).attr('data-count-target'), 10);
            $(this).text(String(Number.isFinite(finalTarget) ? finalTarget : 0));
          }
        });
      }
    }

    function maybeStart(){
      var isVisible = window.UTIL.isElementVisible($stats.get(0), UTIL.svh());
      if (!isVisible) {
        return;
      }
      clearPending();
      MAIN._countTimeoutId = window.setTimeout(function(){
        MAIN._countTimeoutId = null;
        if (MAIN._countHasRun) {
          return;
        }
        startCountAnimation();
      }, delayMs);
    }

    clearPending();
    $window.on(scrollNamespace, maybeStart);
    maybeStart();
  }

  function contactReveal(){
    document.addEventListener('click', function(e){
      if (!e.target.closest('.js-contact-trigger')){
        return;
      }
      $('#schedule').removeClass('visible');
      $('#contact').addClass('visible');
    }, true);
  }

  // Pan .gallery and .iphone-screen images from top to bottom as --scroll-y advances.
  function galleryImagePan(){
    var targets = [];

    function addTargets(rootSelector, frameSelector){
      var roots = document.querySelectorAll(rootSelector);
      var i;
      for (i = 0; i < roots.length; i++) {
        var root = roots[i];
        var imgs = root.querySelectorAll('img');
        var j;
        for (j = 0; j < imgs.length; j++) {
          var img = imgs[j];
          targets.push({
            img: img,
            frame: img.closest(frameSelector) || root,
            host: root.closest('[data-scroll-y-start-vh], [data-scroll-start]') || root.closest('section')
          });
        }
      }
    }

    addTargets('.gallery', '.item');
    addTargets('.animate-screen', '.screen');
    if (!targets.length) {
      return;
    }

    function clamp01(v){
      if (v <= 0) {
        return 0;
      }
      if (v >= 1) {
        return 1;
      }
      return v;
    }

    function isReverse(host){
      var reverseRaw = UTIL.attr(host, 'data-scroll-y-reverse');
      if (reverseRaw == null) {
        return false;
      }
      var reverseNorm = String(reverseRaw).trim().toLowerCase();
      return (reverseNorm === '' || reverseNorm === 'true' || reverseNorm === '1' || reverseNorm === 'reverse');
    }

    function scrollProgress(host){
      if (!host) {
        return 0;
      }
      var value = parseFloat(host.style.getPropertyValue('--scroll-y'));
      if (Number.isFinite(value)) {
        return clamp01(isReverse(host) ? ((100 - value) / 100) : (value / 100));
      }
      var top = host.getBoundingClientRect().top;
      if (window.getComputedStyle(host).position === 'fixed' && host.parentElement) {
        top = host.parentElement.getBoundingClientRect().top;
      }
      if (top > 0) {
        return 0;
      }
      return clamp01((-top) / Math.max(1, host.offsetHeight));
    }

    function frameInnerHeight(frame){
      var style = window.getComputedStyle(frame);
      var pad = (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
      return Math.max(0, frame.clientHeight - pad);
    }

    function update(dt){
      var keepGoing = false;
      var i;
      for (i = 0; i < targets.length; i++) {
        var target = targets[i];
        var progress = scrollProgress(target.host);
        var travel = Math.max(0, target.img.offsetHeight - frameInnerHeight(target.frame));
        target.displayed = approachValue(target.displayed, progress, dt);
        if (Math.abs((target.displayed || 0) - progress) > 0.0004) {
          keepGoing = true;
        } else {
          target.displayed = progress;
        }
        target.img.style.transform = 'translate3d(0, ' + (-travel * target.displayed) + 'px, 0)';
        target.img.style.willChange = 'transform';
      }
      return keepGoing;
    }

    var k;
    for (k = 0; k < targets.length; k++) {
      if (!targets[k].img.complete) {
        targets[k].img.addEventListener('load', update);
      }
    }

    bindScrollFrame(update);
  }

  $(function(){
    // tooltip();
    workItemCursorTip();
    // lazyload();
    clientLogosScrollReveal();
    projectsPinArticle();
    contentScrollPausePin();
    galleryImagePan();
    projectsScrollIntro();
    regionStateOnScroll();
    contentVisibleOnScroll();
    visibleCallbacksOnScroll();
    bodyScrollDirectionClass();
    contactReveal();
  });

  return MAIN;
})(window.MAIN || {}, jQuery, window, document);
